import React, { ReactNode } from "react";
import styles from './InfoMessage.module.scss'
import cn from 'classnames'
import AlarmImg from '../../images/alarm.svg'
import InfoImg from '../../images/info.svg'


interface InfoMessageProps {
    text: ReactNode
    type?: "alarm" | "default"
    className?: string
}
export default function InfoMessage({text, type="default", className}:InfoMessageProps) {
    return <div className={cn(styles.error_message, className, type === 'alarm' ? styles.alarm : styles.default)}>
    {type === "alarm" ? <img src={AlarmImg} alt={'alarm'}></img> : <img src={InfoImg} alt={'info'}></img>}
    {text}
  </div>
}